const UsersPresences = () => import("./views/UsersPresences.vue");
const UsersActivity = () => import("./views/UsersActivity.vue");

const route = "/users";

export default [
  {
    path: `${route}/presences`,
    name: "users.presences",
    component: UsersPresences,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/activity`,
    name: "users.activity",
    component: UsersActivity,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
